import { render } from "./CategoryYearlyExpense.vue?vue&type=template&id=8f53294e"
import script from "./CategoryYearlyExpense.vue?vue&type=script&lang=js"
export * from "./CategoryYearlyExpense.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__